export const ICON_SIZE = {
  DEFAULT: 24,
  SMALL: 16,
};
